import { useSetAtom } from "jotai";

import { useStickyElementObserver } from "~/lib/hooks";

import { appBarStickyHeightAtom } from "./atoms";

export const useAppBarSetStickyHeight = () => {
  const setStickyHeight = useSetAtom(appBarStickyHeightAtom);

  const { reference } = useStickyElementObserver(
    (rect, isSticky) => {
      // For supporting the content is hidden on the top (translateY)
      if (isSticky) setStickyHeight(rect.height + rect.top);
      else setStickyHeight(0);
    },
    { supportScrollEvent: true },
  );

  return {
    reference,
  };
};
